import _toArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { assert, isFunction } from '@polkadot/util';
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";

function getBalance(api, _ref) {
  var _ref2 = _slicedToArray(_ref, 4),
      freeBalance = _ref2[0],
      reservedBalance = _ref2[1],
      frozenFee = _ref2[2],
      frozenMisc = _ref2[3];

  return {
    freeBalance: freeBalance,
    frozenFee: frozenFee,
    frozenMisc: frozenMisc,
    reservedBalance: reservedBalance,
    votingBalance: api.registry.createType('Balance', freeBalance.toBn())
  };
}

function calcBalances(api, _ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      accountId = _ref4[0],
      _ref4$ = _slicedToArray(_ref4[1], 2),
      accountNonce = _ref4$[0],
      balances = _ref4$[1];

  var primary = balances[0];
  assert(primary, 'No balances retrieved for account');
  return _objectSpread({
    accountId: accountId,
    accountNonce: accountNonce,
    additional: balances.filter(function (_, index) {
      return index !== 0;
    }).map(function (b) {
      return getBalance(api, b);
    })
  }, getBalance(api, primary));
} // old


function queryBalancesFree(api, accountId) {
  return api.queryMulti([[api.query.balances.freeBalance, accountId], [api.query.balances.reservedBalance, accountId], [api.query.system.accountNonce, accountId]]).pipe(map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 3),
        freeBalance = _ref6[0],
        reservedBalance = _ref6[1],
        accountNonce = _ref6[2];

    return [accountNonce, [[freeBalance, reservedBalance, api.registry.createType('Balance'), api.registry.createType('Balance')]]];
  }));
}

function queryBalancesAccount(api, accountId) {
  var modules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['balances'];
  var balances = modules.map(function (m) {
    return [api.query[m].account, accountId];
  });

  var extract = function extract(data) {
    return data.map(function (_ref7) {
      var feeFrozen = _ref7.feeFrozen,
          free = _ref7.free,
          miscFrozen = _ref7.miscFrozen,
          reserved = _ref7.reserved;
      return [free, reserved, feeFrozen, miscFrozen];
    });
  };

  return isFunction(api.query.system.account) ? api.queryMulti([[api.query.system.account, accountId]].concat(_toConsumableArray(balances))).pipe(map(function (_ref8) {
    var _ref9 = _toArray(_ref8),
        nonce = _ref9[0].nonce,
        balances = _ref9.slice(1);

    return [nonce, extract(balances)];
  })) : api.queryMulti([[api.query.system.accountNonce, accountId]].concat(_toConsumableArray(balances))).pipe(map(function (_ref10) {
    var _ref11 = _toArray(_ref10),
        nonce = _ref11[0],
        balances = _ref11.slice(1);

    return [nonce, extract(balances)];
  }));
}

function queryCurrent(api, accountId) {
  // AccountInfo is current, support old, eg. Edgeware
  return api.query.system.account(accountId).pipe(map(function (infoOrTuple) {
    var _ref12 = infoOrTuple.nonce ? infoOrTuple.data : infoOrTuple[1],
        feeFrozen = _ref12.feeFrozen,
        free = _ref12.free,
        miscFrozen = _ref12.miscFrozen,
        reserved = _ref12.reserved;

    var accountNonce = infoOrTuple.nonce || infoOrTuple[0];
    return [accountNonce, [[free, reserved, feeFrozen, miscFrozen]]];
  }));
}
/**
 * @name account
 * @param {( AccountIndex | AccountId | Address | string )} address - An accounts Id in different formats.
 * @returns An object containing the results of various balance queries
 * @example
 * <BR>
 *
 * ```javascript
 * const ALICE = 'F7Hs';
 *
 * api.derive.balances.all(ALICE, ({ accountId, lockedBalance }) => {
 *   console.log(`The account ${accountId} has a locked balance ${lockedBalance} units.`);
 * });
 * ```
 */


export function account(instanceId, api) {
  var balanceInstances = api.registry.getModuleInstances(api.runtimeVersion.specName.toString(), 'balances');
  return memo(instanceId, function (address) {
    return api.derive.accounts.accountId(address).pipe(switchMap(function (accountId) {
      return accountId ? combineLatest([of(accountId), balanceInstances ? queryBalancesAccount(api, accountId, balanceInstances) : isFunction(api.query.system.account) ? queryCurrent(api, accountId) : isFunction(api.query.balances.account) ? queryBalancesAccount(api, accountId) : queryBalancesFree(api, accountId)]) : of([api.registry.createType('AccountId'), [api.registry.createType('Index'), [[api.registry.createType('Balance'), api.registry.createType('Balance'), api.registry.createType('Balance'), api.registry.createType('Balance')]]]]);
    }), map(function (result) {
      return calcBalances(api, result);
    }));
  });
}